module.exports = {
	redColor: "#cf1b1c",
};
